import { render, staticRenderFns } from "./NavSecondaryVehicle.vue?vue&type=template&id=6d27a80a&"
import script from "./NavSecondaryVehicle.vue?vue&type=script&lang=js&"
export * from "./NavSecondaryVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports